import type Keycloak from 'keycloak-js';
import type { NavigateFunction } from 'react-router';

import { appPath } from '@/AppRouter';

export const handleAuthNavigation = ({
  authenticated,
  cookiesAccepted,
  navigate,
  keycloak,
}: {
  authenticated: boolean | undefined;
  cookiesAccepted: boolean;
  navigate: NavigateFunction;
  keycloak: Keycloak;
}) => {
  if (!cookiesAccepted) return;
  if (authenticated) {
    navigate(`${appPath}account`);
  } else {
    // Keycloak redirect
    keycloak
      .login({ redirectUri: `${window.location.origin}${appPath}` })
      .catch((error: unknown) => {
        console.error('Login failed:', error);
      });
  }
};
